import { render, staticRenderFns } from "./memberProductCard.vue?vue&type=template&id=d896167c&scoped=true"
import script from "./memberProductCard.vue?vue&type=script&lang=js"
export * from "./memberProductCard.vue?vue&type=script&lang=js"
import style0 from "./memberProductCard.vue?vue&type=style&index=0&id=d896167c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d896167c",
  null
  
)

export default component.exports